// extracted by mini-css-extract-plugin
module.exports = {"productArticles":"ArticlesVideos_productArticles__H61eg"};